import { createStore } from 'react-sweet-state';
const actions = {
  // This action is used by EmbeddedDirectory to get Cloud Id in a remote store.
  setCloudId: cloudId => ({
    setState
  }) => {
    setState({
      cloudId
    });
  }
};
const initialState = {
  cloudId: ''
};

/**
 * Manage states of a site
 */
export const Store = createStore({
  initialState,
  actions,
  name: 'Site'
});